<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Stores
		//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	let settings = $settingsStore;

	let invert = settings[`input:${device.channel}`].invert;
	let cache = invert;

	const sentRequests = async () => {
		const newValueInvert = !invert;
		if (cache === newValueInvert) return;
		const params = { id: device.channel, config: { invert: newValueInvert } };

		const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', params);

		if (res.isok) {
			invert = newValueInvert;
			settings[`input:${device.channel}`].invert = invert;
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast'),
			});
			cache = invert;
		} else {
			toast.open({ type: 'danger', title: $format('invert_input_err_toast') });
			invert = cache;
		}
	};
</script>

<Toggle checked={invert} size="m" on:click={sentRequests} id="toggle-z32r8ao">
	{capFirstChar(
		$format('enable', {
			default: 'Enable',
		}),
	)}
</Toggle>
